module.exports = __webpack_public_path__ + "img/program10.2c026d88.png";